// extracted by mini-css-extract-plugin
export default {"container":"BookSuggestion_container__Oeu3r","title":"BookSuggestion_title__0hLfO"};